const noop = Function.prototype;

// we only want to run this client-side
let clientLogger = {captureException: noop, captureBreadcrumb: noop};
/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Raven) {
    clientLogger = window.Raven;
}

export const LOG_ERROR = {
    level: 'error'
};

export default clientLogger;



// WEBPACK FOOTER //
// ./src/universal/utils/client-logger.js